import axios from 'axios';

axios.defaults.withCredentials = true;

export async function userData() {
  try {
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}user-data`);
    return response

  } catch (error) {
    console.error('Error al obtener los datos del usuario', error);
  }
}